import base from './base';
import channel from './channel-service';
import activitymanage from './activity-manage';
import useActivityLink from './use-activity-link';
import themeActivityType from './theme-activity-type';

export default {
  themeActivityType,
  context: base,
  channel,
  activitymanage,
  useActivityLink,
};
